/**
 *
 * Division
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { get, pick } from "lodash"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import ImportScreen from "components/ImportScreen"
import Loader from "components/Loader"
import DivisionTable from "components/DivisionTable"
import DivisionOrgTable from "components/DivisionOrgTable"
import EmptyButton from "components/EmptyButton"
import ModalCustom from "components/ModalCustom"
import saga from "./saga"
import reducer from "./reducer"
import {
  hasDivisionsWatcher,
  getDivisionsWatcher,
  uploadTemplate,
  getTemplateDivision,
  getSubdivisionsTableWatcher,
  getDivisionsUnassignedWatcher,
  addSubdivisionTableWatcher,
  deleteSubdivisionTableWatcher,
  getDivisionParentsWatcher,
  selectDivisionSuperiorWatcher,
  deleteDivisionTableWatcher,
  getCollaboratorsTableWatcher,
  deleteDivisionsWatcher,
  toggleTableView,
  changeExpandedRows,
  createDivisionWatcher,
} from "./actions"
import {
  makeSelectHasDivisions,
  makeSelectGetDivisions,
  makeSelectIsLoadingDivisions,
  makeSelectSubdivisionsTable,
  makeSelectIsLoadingSubdivisionsTable,
  makeSelectDivisionsUnassigned,
  makeSelectMessageDeleteSubdivision,
  makeSelecDivisionParentsTable,
  makeSelectCollaboratorsTable,
  makeSelectIsLoadingCollaboratorsTable,
  makeSelectIsDownloading,
  makeSelectIsUploading,
  makeSelectTableView,
  makeSelectTreeData,
  makeSelectExpandedRows,
  makeSelectLastOfTree,
  makeSelectOrgFirst,
  makeSelectIsLoadingCreate,
  makeSelectResetDivisionForm,
} from "./selectors"

import emptySvg from "../../images/empty.svg"
import alertSvg from "../../images/alert.svg"
import {
  visitPageSegment,
  PAGE_ORGANIZATION_DIVISION,
} from "../../utils/segment/segmentTracks"
import "./index.less"
import CreateDivisionModal from "../CreateDivisionModal"

/* eslint-disable react/prefer-stateless-function */
export class Division extends React.Component {
  state = {
    file: null,
    idDivisionsSelected: [],
    divisionsSelected: [],
  }

  componentDidMount = () => {
    this.props.hasDivisionsWatcher()
    visitPageSegment(PAGE_ORGANIZATION_DIVISION)
  }

  fileSelectedHandler = (event) => {
    event.preventDefault()
    const fd = new FormData()
    fd.append("uploaded_file", event.target.files[0])
    this.props.uploadTemplate(fd)
    this.fileInput.value = ""
  }

  changeSelectedRows = (selectedRowKeys, selectedRows) => {
    if (selectedRows.length) {
      this.props.toggleModal("buttonDeleteDivisions", true)
    } else {
      this.props.toggleModal("buttonDeleteDivisions", false)
    }

    this.setState({
      idDivisionsSelected: selectedRowKeys,
      divisionsSelected: this.props.tableView == "2"?selectedRows.map(item => item.data):selectedRows,
    })
  }

  render() {
    const rowSelection = {
      onChange: this.changeSelectedRows,
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User", // Column configuration not to be checked
        name: record.name,
      }),
      selectedRowKeys: this.state.idDivisionsSelected,
    }

    if (typeof this.props.hasDivisions === "undefined") {
      return <Loader />
    }

    if (!this.props.hasDivisions) {
      return (
        <ImportScreen
          title="Crea tus divisiones"
          image={emptySvg}
          description={`
            Crea las divisiones de tu organización a las cuales pertenecen tus
            colaboradores.
            <br />
            Una <span>división</span> agrupa a
            los colaboradores en una unidad organizacional (áreas).
          `}
          secondPoint="Llena los campos con las divisiones de tu empresa, y las divisiones a las que estas reportan."
          thirdPoint="Importa el Excel con la información de las divisiones.">
          <EmptyButton
            size="large"
            label="Descargar plantilla"
            loading={this.props.isDownloading}
            onClick={() => this.props.getTemplate(true)}
          />
          <EmptyButton
            size="large"
            onClick={() => this.fileInput.click()}
            loading={this.props.isUploading}
            label="Importar divisiones"
            style={{ marginLeft: "2rem" }}
          />
          <input
            style={{ display: "none" }}
            type="file"
            id="import"
            onChange={this.fileSelectedHandler}
            ref={(fileInput) => (this.fileInput = fileInput)}
          />
        </ImportScreen>
      )
    }

    return (
      <React.Fragment>
        <ModalCustom
          showFooter
          modalOpen={this.props.modalDeleteDivisions}
          onCancel={() => {
            this.props.toggleModal("modalDeleteDivisions", false)
          }}
          onOk={() => {
            const newArr = []
            this.state.divisionsSelected.forEach((item, index) => {
              newArr.push(`id_division[${index}]=${item.id_division}`)
            })

            this.props.deleteDivisions(newArr.join("&"))
            this.props.toggleModal("modalDeleteDivisions", false)
            this.props.toggleModal("buttonDeleteDivisions", false)
            this.setState({ idDivisionsSelected: [], divisionsSelected: [] })
          }}>
          <img src={alertSvg} className="alertIcon" />
          <span style={{ fontSize: 14, fontWeight: 600, marginBottom: '1em' }}>
            ¿Estás seguro de que deseas eliminar{" "}
            {this.state.divisionsSelected.length > 1
              ? "las divisiones seleccionadas"
              : "la división seleccionada"}
            ?
          </span>
          <p style={{ fontWeight: 600, fontSize: 14, marginBottom: 0 }}>
            Se perderá la información de los embajadores asociados a {this.state.divisionsSelected.length > 1
              ? "estas"
              : "esta"}.
          </p>
          <p style={{ fontSize: 13 }}>
            Asimismo, deberás asignarle una nueva división superior a las<br /> subdivisiones dentro.
          </p>
        </ModalCustom>
        {this.props.tableView == "2" && (
          <DivisionOrgTable
            data={this.props.getDivisions}
            tableView={this.props.tableView}
            toggleTableView={this.props.toggleTableView}
            treeData={this.props.treeData}
            expandedRows={this.props.expandedRows}
            changeExpandedRows={this.props.changeExpandedRows}
            getDivisions={this.props.getDivisionsWatcher}
            lastOfTree={this.props.lastOfTree}
            isLoading={this.props.isLoadingDivisions}
            first={this.props.first}
            buttonDeleteDivisions={this.props.buttonDeleteDivisions}
            toggleModal={this.props.toggleModal}
            rowSelection={rowSelection}
            hasDivisions={this.props.hasDivisions}
            getTemplateDivision={this.props.getTemplateDivision}
            createModal={this.props.createModal}
            toggleCreateModal={this.props.toggleCreateModal}
          />
        )}
        {this.props.tableView == "1" && (
          <DivisionTable
            current_page={get(this.props.getDivisions, "current_page", 1)}
            total={get(this.props.getDivisions, "total", 0)}
            per_page={get(this.props.getDivisions, "per_page", 15)}
            divisionsFilter={get(this.props.getDivisions, "divisions", [])}
            divisionsParentFilter={get(this.props.getDivisions, "divisionsParent", [])}
            levelFilter={get(this.props.getDivisions, "levels", [])}
            tableView={this.props.tableView}
            toggleTableView={this.props.toggleTableView}
            data={get(this.props.getDivisions, "data", [])}
            rowSelection={rowSelection}
            isLoading={this.props.isLoadingDivisions}
            createModal={this.props.createModal}
            toggleCreateModal={this.props.toggleCreateModal}
            getDivisions={this.props.getDivisionsWatcher}
            buttonDeleteDivisions={this.props.buttonDeleteDivisions}
            toggleModal={this.props.toggleModal}
            hasDivisions={this.props.hasDivisions}
            getTemplateDivision={this.props.getTemplateDivision}
            {...pick(this.props, [
              "getSubdivisionsTable",
              "isLoadingSubdivisionsTable",
              "subdivisionsTable",
              "getDivisionsUnassigned",
              "divisionsUnassigned",
              "addSubdivisionTable",
              "deleteSubdivisionTable",
              "messageDeleteSubdivision",
              "getDivisionParents",
              "divisionParents",
              "selectDivisionSuperior",
              "deleteDivisionTable",
              "collaboratorsTable",
              "getCollaboratorsTable",
              "isLoadingCollaboratorsTable",
            ])}
          />
        )}
        <CreateDivisionModal
          data={get(this.props.getDivisions, "data", [])}
          divisionsSimple={get(this.props.getDivisions, "divisionsSimple", [])}
          visible={!!this.props.createModal}
          createDivisionProp={this.props.createDivisionWatcher}
          isLoadingCreateDivision={this.props.isLoadingCreateDivision}
          resetDivisionForm={this.props.resetDivisionForm}
          onCancel={() => this.props.toggleCreateModal(false)}
          tableView={this.props.tableView}
        />

      </React.Fragment>
    )

  }
}

Division.propTypes = { hasDivisionsWatcher: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  tableView: makeSelectTableView(),
  hasDivisions: makeSelectHasDivisions(),
  getDivisions: makeSelectGetDivisions(),
  isLoadingDivisions: makeSelectIsLoadingDivisions(),
  subdivisionsTable: makeSelectSubdivisionsTable(),
  isLoadingSubdivisionsTable: makeSelectIsLoadingSubdivisionsTable(),
  divisionsUnassigned: makeSelectDivisionsUnassigned(),
  messageDeleteSubdivision: makeSelectMessageDeleteSubdivision(),
  divisionParents: makeSelecDivisionParentsTable(),
  collaboratorsTable: makeSelectCollaboratorsTable(),
  isLoadingCollaboratorsTable: makeSelectIsLoadingCollaboratorsTable(),
  isDownloading: makeSelectIsDownloading(),
  isUploading: makeSelectIsUploading(),
  treeData: makeSelectTreeData(),
  expandedRows: makeSelectExpandedRows(),
  lastOfTree: makeSelectLastOfTree(),
  first: makeSelectOrgFirst(),
  isLoadingCreateDivision: makeSelectIsLoadingCreate(),
  resetDivisionForm: makeSelectResetDivisionForm()
})

function mapDispatchToProps(dispatch) {
  return {
    toggleTableView: (params) => dispatch(toggleTableView(params)),
    hasDivisionsWatcher: () => dispatch(hasDivisionsWatcher()),
    getDivisionsWatcher: (params) => dispatch(getDivisionsWatcher(params)),
    uploadTemplate: (params) => dispatch(uploadTemplate(params)),
    getTemplate: (params) => dispatch(getTemplateDivision(params)),
    getSubdivisionsTable: (params) =>
      dispatch(getSubdivisionsTableWatcher(params)),
    getDivisionsUnassigned: (params) =>
      dispatch(getDivisionsUnassignedWatcher(params)),
    addSubdivisionTable: (params) =>
      dispatch(addSubdivisionTableWatcher(params)),
    deleteSubdivisionTable: (params) =>
      dispatch(deleteSubdivisionTableWatcher(params)),
    getDivisionParents: (params) => dispatch(getDivisionParentsWatcher(params)),
    selectDivisionSuperior: (params) =>
      dispatch(selectDivisionSuperiorWatcher(params)),
    deleteDivisionTable: (params) =>
      dispatch(deleteDivisionTableWatcher(params)),
    getCollaboratorsTable: (params) =>
      dispatch(getCollaboratorsTableWatcher(params)),
    deleteDivisions: (params) => dispatch(deleteDivisionsWatcher(params)),
    changeExpandedRows: (params) => dispatch(changeExpandedRows(params)),
    createDivisionWatcher: (params) => dispatch(createDivisionWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "division", reducer })
const withSaga = injectSaga({ key: "division", saga })

export default compose(withReducer, withSaga, withConnect)(Division)
